import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { loadFields } from './store/fields/actions';
import { saveDeal } from 'bundles/apex/deals/form/store/deal/actions';

import FullForm from './layouts/full';
import LoadingSpinner from 'components/loading_spinner';
import OverviewForm from './layouts/overview';
import layouts from './layouts';

import './styles.scss';

export function DealForm({ dealType, fields, layout, loadFields, saveDeal, stage, onCancel, onSave }) {
  React.useEffect(() => {
    if (!fields) {
      loadFields();
    }
  }, []);

  React.useEffect(() => {
    if (dealType && stage && fields && Object.values(fields).every(field => field.hidden)) {
      saveDeal(onSave);
    }
  }, [fields]);

  if (!fields) {
    return <LoadingSpinner/>;
  }

  let Component;
  if (layout === 'overview') {
    Component = OverviewForm;
  } else {
    Component = FullForm;
  }

  return <Component onCancel={onCancel} onSave={onSave} />;
}

DealForm.propTypes = {
  dealType: PropTypes.string,
  fields: PropTypes.object,
  layout: PropTypes.oneOf(Object.values(layouts)),
  loadFields: PropTypes.func.isRequired,
  saveDeal: PropTypes.func,
  stage: PropTypes.string,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
};

const mapStateToProps = ({ fields, deal: { dealType, stage } }) => ({
  dealType,
  fields,
  stage,
});


const mapDispatchToProps = {
  loadFields,
  saveDeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealForm);
